module.exports = __webpack_public_path__ + "static/media/nyu.2df001d6.png";